import React from 'react';
import styled from 'styled-components';
import theme from '@styles/theme';
import { BoldFont, RegularFont } from './StyledComponents';

type StyledInputProps = {
    width?: number;
    height?: number;
    margin?: string;
    border?: string;
    title?: string;
    subTitle?: string;
    optionalText?: string;
    name?: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
    maxLength?: number;
    disabled?: boolean;
    placeholder?: string;
};

const StyledTextarea = ({
    width,
    height = 100,
    margin,
    border = `1px solid ${theme.colors.ultraLightGrayBorder}`,
    title = '',
    subTitle,
    optionalText = '',
    name = '',
    value = '',
    onChange = () => null,
    onKeyDown = () => null,
    maxLength = 200,
    disabled = false,
    placeholder = ''
}: StyledInputProps) => {
    // if (ROW) {
    // return (
    //     <Wrapper $margin={margin}>
    //         {title && (
    //             <RowTitle>
    //                 {title}
    //                 {optionalText && <GrayText>{optionalText}</GrayText>}
    //             </RowTitle>
    //         )}
    //         <Textarea
    //             $width={width}
    //             $height={height}
    //             $border={border}
    //             name={name}
    //             value={value}
    //             onChange={onChange}
    //             onKeyDown={onKeyDown}
    //             maxLength={maxLength}
    //             disabled={disabled}
    //             placeholder={placeholder}
    //         />
    //     </Wrapper>
    // );
    // }
    return (
        <Wrapper $width={width} $margin={margin}>
            {title && (
                <FlexBox>
                    <ColumnTitle>
                        {title}
                        {subTitle && <SubTitle>{subTitle}</SubTitle>}
                    </ColumnTitle>
                    <GrayText>
                        ({value.length || 0} / {maxLength})
                    </GrayText>
                </FlexBox>
            )}
            <Textarea
                $height={height}
                $border={border}
                name={name}
                value={value}
                onChange={onChange}
                onKeyDown={onKeyDown}
                maxLength={maxLength}
                disabled={disabled}
                placeholder={placeholder}
            />
        </Wrapper>
    );
};

export default React.memo(StyledTextarea);

const Wrapper = styled.div<{
    $width?: number;
    $margin?: string;
}>`
    display: block;
    /* display: flex; */
    margin: ${({ $margin }) => ($margin ? $margin : 0)};
    width: ${({ $width }) => ($width ? `${$width}px` : '100%')};
`;
const FlexBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
`;
const ColumnTitle = styled(RegularFont)`
    font-size: 14px;
`;
const RowTitle = styled(BoldFont)`
    width: 180px;
`;
const SubTitle = styled.span`
    display: inline-block;
    margin-left: 4px;
    font-size: 14px;
    color: ${theme.colors.sidebarGrayFontColor};
`;
const GrayText = styled.span`
    display: inline-block;
    /* margin-left: 4px; */
    font-size: 14px;
    color: ${theme.colors.deepGrayFontColor};
`;
const Textarea = styled.textarea<{
    $width?: number;
    $height?: number;
    $border?: string;
}>`
    display: block;
    padding: 14px 12px;
    width: ${({ $width }) => ($width ? `${$width}px` : '100%')};
    height: ${({ $height }) => $height}px;
    font-size: 15px;
    border: ${({ $border }) => $border};
    border-radius: 4px;
    white-space: pre-wrap;
`;
